<template>
  <button
      class="btn"
      :class="{ 'btn--simple' : simple }"
      @click="clearFilters"
      type="button"
  >
    <span class="btn__text">Clear Filters</span>
    <span class="btn__swoop"></span>
  </button>
</template>

<script>
export default {
  name: 'ClearFilters',
  methods: {
    clearFilters () {
      this.$store.commit('filters/reset')
      this.$store.commit('filters/clearSearch')
    }
  },
  props: {
    simple: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped lang="scss">
  .btn {
    margin-top: 0.5rem;

    &--simple {
      background: none;
      margin-top: 0;
      outline: none;
      padding: 0;

      .btn__swoop {
        display: none;
      }

      .btn__text {
        font-size: 1em;
      }
    }
  }
</style>
